import { z } from "zod";
import { DateISO, ReportKind } from "../enums.js";
export const Report = z.object({
    id: z.string().uuid(),
    kind: ReportKind,
    period_start: DateISO,
    period_end: DateISO,
    scope: z.string(),
    headline: z.string().nullable(),
    markdown: z.string().nullable(),
    status: z.enum(["generating", "ready", "failed"]),
    error: z.string().nullable(),
    generated_at: z.string().nullable(),
    read: z.boolean(),
    created_at: z.string(),
});
export const GenerateReportInput = z.object({
    kind: ReportKind.default("adhoc"),
    period_start: DateISO.optional(),
    period_end: DateISO.optional(),
    project_id: z.string().min(1).optional(),
});
/** What the narrative model returns. */
export const ReportNarrative = z.object({
    headline: z.string().describe("One line, under 100 characters, the single most important thing this period"),
    markdown: z.string().describe("The report body in Markdown"),
});
//# sourceMappingURL=report.js.map